import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {ApiService} from "../api.service";
import {CommonService} from "../common.service";

declare var echarts:any;
declare var jquery:any;
declare var jQuery:any;
declare var $ :any;

@Component({
    selector: 'app-graduation',
    templateUrl: './graduation.component.html',
    styleUrls: ['./graduation.component.css',]
})
export class GraduationComponent implements OnInit, AfterViewInit {
    graduationPage: boolean;
    selectedAbilityIndex: number;
    Arr = Array; //Array type captured in a variable

    learningPathId: number;
    userId: number;
    firstEntry: number;
    data: any;
    graduation: any;
    characterReport: any;
    capacityDevelopmentDisplay: boolean;
    notStartWrapDisplay: boolean;

    learningTourId: any;

    option: any;

    scrollTop:any;
    hideStamp: any;


    constructor(private route: ActivatedRoute,
                private router: Router,
                private apiService: ApiService,
                private commonService: CommonService) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.learningTourId = params['learningTourId'];
            this.userId = params['userId'];
            this.firstEntry = params['firstEntry'];
            this.getGraduationData();
            //this.getGraduationMockData();
        });

        /*let that = this;
        setTimeout(function () {
            if(that.firstEntry == 1){
                that.openingAnimation();
            }
        },100);*/

        if (this.userId > 0) {
            this.graduationPage = false;
        }else{
            this.graduationPage = true;
            this.apiService.ajax({
                'type':'get',
                'url': '/sr/onceino/301',
                'data':{}
            }).subscribe(result=>{
                this.hideStamp = result == 1 ? false : true;
                if(!result){
                    let that = this;
                    setTimeout(function () {
                        that.openingAnimation();
                    },100);
                    this.apiService.ajax({
                        'type':'post',
                        'url': '/sr/onceino/301',
                        'data':{}
                    }).subscribe(result=>{

                    });
                }
            });
        }

    }

    getGraduationData() {
        /*this.apiService.getGraduationByLearningPathId("" + this.learningPathId + "", "" + this.userId + "").subscribe(graduation => {
            this.graduation = graduation;
            this.setChart();
        });*/

        this.apiService.ajax({
            'type':'get',
            'url':'/api/learningtour/'+this.learningTourId+'/graduation/'+this.userId,
            'data':{}
        }).subscribe(result=>{
            this.data = result;
            this.graduation = result.learningPaths[0];
            this.data = result;
            this.selectedAbilityIndex = 0;
            this.characterReport = result.characterReport;
            this.setChart();
            console.log(this.graduation);
        });
    }

    setChart(){
        var that = this;
        jQuery.getScript("/assets/js/echarts.min.js", function(data, status, jqxhr) {
            if (that.characterReport) {
                let myChart = echarts.init(document.getElementById('radar'));

                let option = {
                    radar: {
                        name: {
                            textStyle: {
                                color: '#4a4a4a',
                                fontSize: 14
                            }
                        },
                        splitArea: {
                            show: false
                        },
                        splitLine: {
                            lineStyle: {
                                width: 1,
                                opacity: 0.3,
                                color: '#d1d2d5',
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                width: 1,
                                opacity: 0.3,
                                color: '#d1d2d5',
                            }
                        },
                        indicator: [
                            {name: '尽责', max: 100},
                            {name: '开放', max: 100},
                            {name: '情绪稳定', max: 100},
                            {name: '宜人', max: 100},
                            {name: '外向', max: 100}
                        ]
                    },
                    series: [{
                        type: 'radar',
                        itemStyle: {
                            normal: {
                                lineStyle: {
                                    color: '#7297e7',
                                    width: 2
                                }
                            }
                        },
                        data: [
                            {
                                value: [that.characterReport.responsibility, that.characterReport.open, that.characterReport.emotionality, that.characterReport.delightful, that.characterReport.extroversion],
                                symbol: 'none',
                                areaStyle: {
                                    normal: {
                                        opacity: 0.4,
                                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                            offset: 0,
                                            color: '#63c0f7'
                                        }, {
                                            offset: 1,
                                            color: '#7c64ff'
                                        }])
                                    }
                                }
                            }
                        ]
                    }]
                };

                myChart.setOption(option);
            }
        });
    }

    getGraduationMockData() {
        this.graduation = {
            "headimgurl":"http://wx.qlogo.cn/mmopen/vi_32/PiajxSqBRaEJcRMcqnH1PfkfWSkfRLhWv4y3HLvP0DSnLlxF5uy7sRm5MI8GfRoGia6iabF5sicb5C5zRD9uFC31HA/132",
            "userName":"王皓",
            "personalReportStatus":1,
            "companyName":"Housing Company",
            "rank":5,
            "lessonCount":9,
            "questionCount":51,
            "preSurveyLevel":2,
            "postSurveyLevel":3/*,
            "characterReport":{
                "emotionality":65,
                "delightful":75,
                "extroversion":85,
                "responsibility":95,
                "open":100
            }*/
        };

        var that = this;
        jQuery.getScript("/assets/js/echarts.min.js", function(data, status, jqxhr) {
            let myChart = echarts.init(document.getElementById('radar'));

            let option =  {
                radar: {
                    name: {
                        textStyle: {
                            color: '#4a4a4a',
                            fontSize: 14
                        }
                    },
                    splitArea: {
                        show: false
                    },
                    splitLine: {
                        lineStyle: {
                            width: 1,
                            opacity:0.3,
                            color: '#d1d2d5',
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            width: 1,
                            opacity:0.3,
                            color: '#d1d2d5',
                        }
                    },
                    indicator: [
                        { name: '尽责', max: 100},
                        { name: '开放', max: 100},
                        { name: '情绪稳定', max: 100},
                        { name: '宜人', max: 100},
                        { name: '外向', max: 100}
                    ]
                },
                series: [{
                    type: 'radar',
                    itemStyle: {
                        normal: {
                            lineStyle: {
                                color : '#7297e7',
                                width : 2
                            }
                        }
                    },
                    data : [
                        {
                            value : [65, 55, 75, 85, 90],
                            symbol: 'none',
                            areaStyle: {
                                normal: {
                                    opacity: 0.4,
                                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                        offset: 0,
                                        color: '#63c0f7'
                                    }, {
                                        offset: 1,
                                        color: '#7c64ff'
                                    }])
                                }
                            }
                        }
                    ]
                }]
            };

            myChart.setOption(option);
        });
    }

    openingAnimation(){
        if(this.graduationPage){
            if(this.graduation.personalReportStatus==1){
                document.getElementById("shade").ontouchmove=function(e){e.preventDefault();}
                document.getElementById("graduatedPic").ontouchmove=function(e){e.preventDefault();}
                document.getElementById("graduatedText").ontouchmove=function(e){e.preventDefault();}
                $("#shade").fadeIn(1000);
                $("#graduatedPic").animate({
                    "left":"50%"
                },1000);
                $("#graduatedText").animate({
                    "left":"0"
                },1000);
                setTimeout(function () {
                    $("#graduatedText").fadeOut();
                    $("#graduatedPic").animate({
                        "width": "1.72rem",
                        "height": "1.72rem",
                        "left": "7.69rem",
                        "top": "5.31rem"
                    },1000,function () {
                        $("#shade").fadeOut();
                        $("#graduatedPic").fadeOut();
                        $("#stampGraduated").show();
                    });
                },4000);
            }else{
                document.getElementById("shade").ontouchmove=function(e){e.preventDefault();}
                document.getElementById("failedPic").ontouchmove=function(e){e.preventDefault();}
                document.getElementById("failedText").ontouchmove=function(e){e.preventDefault();}
                $("#shade").fadeIn(1000);
                $("#failedPic").animate({
                    "left":"50%"
                },1000);
                $("#failedText").animate({
                    "left":"0"
                },1000);
                setTimeout(function () {
                    $("#failedText").fadeOut();
                    $("#failedPic").animate({
                        "width": "1.92rem",
                        "height": "1.2rem",
                        "left": "7.705rem",
                        "top": "4.81rem"
                    },1000,function () {
                        $("#shade").fadeOut();
                        $("#failedPic").fadeOut();
                        $("#stampFailed").show();
                    });
                },4000);
            }
        }
    }

    ngAfterViewInit(){
        this.commonService.initPage();



        var that = this;
        if (this.data) {
            $("#headPortrait").css("background-image", "url(" + this.data.headimgurl + ")");
        }
        else {
            var headerInterval = setInterval(function () {
                if (that.data) {
                    $("#headPortrait").css("background-image", "url(" + that.data.headimgurl + ")");
                    clearInterval(headerInterval);
                }
            }, 100);
        }
    }

    selectAbility(index:number){
        this.selectedAbilityIndex = index;
    }

    showDnaReport(){
        if(this.characterReport){
            $("#dnaReport").show();
            $("#closeBtnReport2").show();
            $("#dnaReport").animate({
                "top": "0.9rem"
            });
            $("#closeBtnReport2").animate({
                "top": "10rem"
            });
            $("#shade").fadeIn();
            this.scrollTop = document.body.scrollTop | document.documentElement.scrollTop;
            $("#wrap").addClass("fixed");
            $("#wrap").scrollTop(this.scrollTop);
        }else{
            $("#noDnaReport").show();
            $("#closeBtnReport2").show();
            $("#noDnaReport").animate({
                "top": "0.9rem"
            });
            $("#closeBtnReport2").animate({
                "top": "10rem"
            });
            $("#shade").fadeIn();
            document.getElementById('noDnaReport').ontouchmove = function (e) {
                e.preventDefault();
            }
            document.getElementById('noDnaReportPic').ontouchmove = function (e) {
                e.preventDefault();
            }
            document.getElementById('noDnaReportText').ontouchmove = function (e) {
                e.preventDefault();
            }
            document.getElementById('shade').ontouchmove = function (e) {
                e.preventDefault();
            }
            document.getElementById('closeBtnReport2').ontouchmove = function (e) {
                e.preventDefault();
            }

        }

    }

    onCloseBtnReportClick(){
        if(this.characterReport){
            $("#dnaReport").animate({
                "top": "20.9rem"
            },function(){
                $("#dnaReport").hide();
            });
            $("#closeBtnReport2").animate({
                "top": "30rem"
            },function(){
                $("#closeBtnReport2").hide();
            });
            $("#shade").fadeOut();
            $("#wrap").removeClass("fixed");
            window.scrollTo(0, this.scrollTop);
        }else{
            $("#noDnaReport").animate({
                "top": "20.9rem"
            },function(){
                $("#noDnaReport").hide();
            });
            $("#closeBtnReport2").animate({
                "top": "30rem"
            },function(){
                $("#closeBtnReport2").hide();
            });
            $("#shade").fadeOut();
        }

    }

    close() {
        if (this.userId > 0) {
            let link = ['hr-report'];
            this.router.navigate(link);
        }
        else {
            let link = ['learning-map'];
            this.router.navigate(link);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/graduation/graduation.component.ts